function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M7.81 2h8.37C19.83 2 22 4.17 22 7.81v8.37c0 3.64-2.17 5.81-5.81 5.81H7.81C4.17 22 2 19.83 2 16.19V7.81C2 4.17 4.17 2 7.81 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.24 6.25c-.42 0-.75.34-.75.75v8.19l-1.67-1.67a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06l2.95 2.95a.776.776 0 00.53.22c.1 0 .19-.02.29-.06.18-.08.33-.22.41-.41.04-.09.06-.19.06-.29V7a.77.77 0 00-.76-.75zm7 3.17l-2.95-2.95a.776.776 0 00-.24-.16.707.707 0 00-.57 0c-.18.08-.33.22-.41.41-.04.09-.06.18-.06.28v10c0 .41.34.75.75.75s.75-.34.75-.75V8.81l1.67 1.67c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06z"
})));